module.exports = __webpack_public_path__ + "static/media/chalkboard.77096e49.svg";